<flw-button (click)="onHandleCollapse()" theme="white">
    <flw-icon [name]="openAll ? 'chevron_up' : 'chevron_down'" slot="only-icon" theme="white" />
</flw-button>